import React from 'react';

import CopyTextInput from '@dashboard/components/form/fields/CopyTextInput';
import { type FWebhookEndpointFragment } from '@dashboard/generated/wp/platform';
import { Box } from '@mui/material';

type Props = {
  item: FWebhookEndpointFragment;
};
export default function WebhookCard({ item }: Props) {
  return (
    <Box key={item.id}>
      <CopyTextInput helperText={item.name} label="Endpoint URL" value={item.url} margin="dense" />
    </Box>
  );
}
